import React from 'react'
import { 
    
    HashRouter as Router,
    Redirect,
    Route,
    Switch
} from 'react-router-dom'
import { FAQScreen } from '../components/mainScreen/FAQScreen'
import { HomeScreen } from '../components/mainScreen/HomeScreen'
import { HowWeAre } from '../components/mainScreen/HowWeAre'
import { PoliticaScreen } from '../components/mainScreen/PoliticaScreen'
import { PrivacidadScreen } from '../components/mainScreen/PrivacidadScreen'
import { EmpresasScreen } from '../components/mainScreen/EmpresasScreen'
import { FreelancersScreen } from '../components/mainScreen/FreelancersScreen';

import Header from '../components/partials/Header'
import { Footer } from '../components/partials/Footer'
import WhatsApp from '../components/WhatsApp'

export const AppRouter = () => {
    return (
        <Router>
            <Switch>
                <Route exact path="/empresas" component={ EmpresasScreen }></Route>

                <Route exact path="/freelancers" component={ FreelancersScreen }></Route>

                {/* LAS PÁGINAS VIEJAS: Enueltas para que mantengan su estructura original */}
                <Route>
                    <>
                        <Header />
                        <Switch>
                            <Route exact path="/home" component={ HomeScreen }></Route>
                            <Route exact path="/quienes-somos" component={ HowWeAre }></Route>
                            <Route exact path="/preguntas-frecuentes" component = { FAQScreen }></Route>
                            <Route exact path="/aviso-de-privacidad" component = { PrivacidadScreen }></Route>
                            <Redirect to="/home"></Redirect>
                        </Switch>
                        <Footer />
                        <WhatsApp />
                    </>
                </Route>
            </Switch>
        </Router>
    )
}